// React
import React, { useState, useRef, useEffect } from "react";
import * as ModelCache from "../libs/ModelCache";
import * as EventifyAPI from "../libs/EventifyAPI";

import { Spinner } from "react-bootstrap";

import ListSidePaneListSection from "../components/ListSidePaneListSection";

// Style
import "react-bootstrap-typeahead/css/Typeahead.css";
import "react-bootstrap-typeahead/css/Typeahead-bs4.css";

// UUID
const uuidv4 = require("uuid/v4");

// DateTime
const { DateTime } = require("luxon");

const ListSidePane = React.forwardRef((props, ref) => {
  const [personid, setPersonId] = useState("");
  const [person, setPerson] = useState({});
  const [reloadProtocol, setReloadProtocol] = useState(null);
  const [lists, setLists] = useState([]);
  const [listsInfo, setListsInfo] = useState({});
  const [notesToUserInfo, setNotesToUserInfo] = useState({});
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [affinityData, setAffinityData] = useState({});

  // Default modal stuff
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);

  // Allow hierarchy to call functions on this component
  // the ref might not actually be necessary
  const modalComponentRef = React.useRef();
  React.useImperativeHandle(ref, () => ({
    handleShowImperative: passedPersonId => {
      handleShow();
      if (personid !== passedPersonId) {
        setLoading(true);
        setPersonId(passedPersonId);
        setLists([]);
        setNotes([]);
        setAffinityData({});
        EventifyAPI.getListsForPersonId(
          passedPersonId
        ).then(result => {
          setLists(result);
          setReloadProtocol(uuidv4());
        });
        EventifyAPI.getNotesforPersonId(
          passedPersonId
        ).then(result => {
          setLoading(false);
          setNotes(result);
          setReloadProtocol(uuidv4());
        });
        ModelCache.getPersonForId(
          passedPersonId,
          result => {
            setPerson(result);
            setReloadProtocol(uuidv4());
            EventifyAPI.grabAffinityDateForPerson(
              result.name,
              result.email
            ).then( (result) => {
              console.log(result);
              setAffinityData(result);
              setReloadProtocol(uuidv4());
            });
          }
        );
      }
    }
  }));

  useEffect(() => {
    onLoad();
  }, []);

  async function onLoad() {}

  function closeMe() {
    setShow(false);
  }

  function renderLists(chonks) {
    return (
      <div>
        {chonks.map((list, n) =>
          <ListSidePaneListSection
            email={props.email}
            organizationid={props.organizationid}
            list={list}
            notes={notes} />
        )}
      </div>
    );
  }

  function renderAffinityData(data) {
    if (data.foundMatchedPerson == null || typeof data.foundMatchedPerson === "undefined") {
      return (
        <p>No Affinity Profile</p>
      );
    }

    if (data.doesNotExist == true) {
      return (
        <p>No Affinity Profile</p>
      );
    }

    const organizations = data.organizations;

    const affinityLink = "https://8partners.affinity.co/persons/" + data.foundMatchedPerson.id;

    if (organizations == null || typeof organizations === "undefined") {
      return (
        <p>No Affinity Profile</p>
      );
    }
    return (
      <>
        <div className="affinity-info">
          <a href={affinityLink}>🔗 Affinity Profile</a>
          <br />
          <h5>Companies</h5>
          {organizations.map( (organization) => <p><a href={`https://${organization.domain}`}>{organization.name}</a></p>)}
        </div>
      </>
    )
  }

  return (
    <div className={`${show ? "expanded contact-details-pane" : "hidden"}`}>
      <div className="contact-details_header">
        <div className="panel-close" onClick={closeMe}>
          <p>x</p>
        </div>
        <div className="panel-header-details">
          <h3>
            {person.name === null || typeof person.name === "undefined"
              ? "Loading..."
              : person.name}
          </h3>
          <p style={{ display: "inline-block" }}>
            {person.name === null || typeof person.name === "undefined"
              ? "Loading..."
              : person.email}
          </p>
        </div>
      </div>

      <div className="contact-details">
        <h3 key="affinityTitle">Affinity</h3>
        {renderAffinityData(affinityData)}
        <h3 key="listsTitle">Lists</h3>
        { loading == true
        ? <Spinner animation="border" />
        : <></>}
        {renderLists(lists)}
      </div>
    </div>
  );
});

export default ListSidePane;
